import React from "react";
import { PropTypes } from "prop-types";

function AppleIcon({ className, color }) {
  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 384 512"
      version="1.1"
      id="svg835"
    >
      <defs id="defs839" />
      <path
        fill={color || "inherit"}
        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
        id="path833"
      />
      <path
        fill={color || "inherit"}
        style={{ strokeWidth: 1.94493, fillOpacity: 1 }}
        d="M 111.75349,476.64276 C 81.280507,466.68728 39.788109,411.4677 19.756657,354.21002 6.9657004,317.64847 2.2745645,273.04001 7.9368548,241.81436 17.162077,190.94032 52.775469,153.20569 100.86711,143.34892 c 18.67517,-3.82763 31.9259,-1.92076 64.20528,9.23956 12.30385,4.25395 25.54214,7.73445 29.41842,7.73445 3.87629,0 18.83701,-4.05434 33.24606,-9.00965 22.37868,-7.69608 29.03391,-9.14744 45.64759,-9.95475 32.85649,-1.59661 61.20104,8.69547 83.1458,30.19075 5.08113,4.97706 9.23842,9.98742 9.23842,11.13414 0,1.14671 -2.40685,3.52053 -5.34856,5.27515 -14.72161,8.78088 -31.27683,29.90353 -37.15484,47.40549 -12.38779,36.88514 -3.36813,75.94676 23.78044,102.98625 6.55364,6.5273 16.42872,14.39054 21.9446,17.47384 l 10.02892,5.60603 -3.86759,9.81216 c -12.67553,32.15805 -36.27086,69.14224 -55.4904,86.97765 -22.45086,20.834 -42.33812,24.90278 -70.58843,14.44177 -23.54619,-8.71907 -33.12231,-10.82696 -49.29782,-10.85143 -12.69777,-0.0195 -19.23226,1.30229 -38.89862,7.86656 -27.25108,9.09596 -37.95623,10.614 -49.12289,6.96587 z"
        id="path843"
      />
      <path
        fill={color || "inherit"}
        style={{ strokeWidth: 1.94493, fillOpacity: 1 }}
        d="m 193.62395,136.9541 c -0.67406,-1.09065 -0.60144,-7.00028 0.16137,-13.13249 4.31704,-34.704274 25.84414,-64.445419 58.14362,-80.329362 8.5914,-4.224998 19.77801,-8.230082 24.85914,-8.900185 l 9.23843,-1.21837 -0.0287,7.557854 c -0.14252,37.467764 -30.65858,80.269333 -66.09891,92.709763 -11.78667,4.13742 -24.75474,5.77246 -26.2749,3.31279 z"
        id="path845"
      />
    </svg>
  );
}

AppleIcon.defaultProps = {
  color: "#888888",
};

AppleIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default AppleIcon;
